import { createSelector } from 'reselect'
// import { List } from 'immutable'

const departmentSelector = state => state.get('department')

export const getIsFetching = createSelector(
  departmentSelector,
  departmentImmutable => {
    const department = departmentImmutable.toJS()
    return department.departmentCreate.isFetching
    || department.departmentEdit.isFetching
    || department.departmentDeactivate.isFetching
    || department.departmentGet.isFetching
    || department.departmentList.isFetching
    || department.departmentExport.isFetching
  }
)
export const getCreateDepartmentData = createSelector(
  departmentSelector,
  departmentImmutable => {
    const department = departmentImmutable.toJS()
    return department.departmentCreate
  }
)
export const getEditDepartmentData = createSelector(
  departmentSelector,
  departmentImmutable => {
    const department = departmentImmutable.toJS()
    return department.departmentEdit
  }
)
export const getDeactivateDepartmentData = createSelector(
  departmentSelector,
  departmentImmutable => {
    const department = departmentImmutable.toJS()
    return department.departmentDeactivate
  }
)
export const getGetDepartmentData = createSelector(
  departmentSelector,
  departmentImmutable => {
    const department = departmentImmutable.toJS()
    return department.departmentGet.department
  }
)
export const getListDepartment = createSelector(
  departmentSelector,
  departmentImmutable => {
    const department = departmentImmutable.toJS()
    return department.departmentList.department || []
  }
)
export const getExportURL = createSelector(
  departmentSelector,
  departmentImmutable => {
    const department = departmentImmutable.toJS()
    return department.departmentExport.url
  }
)
export const redirectDepartment = createSelector(
  departmentSelector,
  departmentImmutable => {
    const department = departmentImmutable.toJS()
    return ({
      redirect: (department.departmentCreate.redirect
      || department.departmentEdit.redirect
      || department.departmentDeactivate.redirect
      || department.departmentGet.redirect
      || department.departmentList.redirect
      || department.departmentExport.redirect),
      isAuthenticated: (department.departmentCreate.isAuthenticated
      || department.departmentEdit.isAuthenticated
      || department.departmentDeactivate.isAuthenticated
      || department.departmentGet.isAuthenticated
      || department.departmentList.isAuthenticated
      || department.departmentExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/department/department-selector.js